<div class="footer-container">
      <div
        id="footer"
        class="footer ng-scope"
        ng-controller="FooterController as footerCtrl"
      >
        <div class="container row">
          <div class="col-12 col-lg-6 hidden-xs">@2027 Siemens</div>

          <div class="col-12 col-lg-6 hidden-xs">
            <a href="https://www.maritz.com/" target="_blank"
              >Powered by
              <img class="mtlogo" alt="Maritz" src="assets/images/maritz-logo.svg"
            /></a>
          </div>
        </div>
      </div>
    </div>